import { Button } from 'antd';
import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Link } from 'react-router-dom';
import NotifyAlert from '../../components/Notify/NotifyAlert';
import '../../components/Notify/NotifyAlert.css';
import ModuleApi from '../../functions/api/user/ModuleApi';
import MyUtil from '../../functions/MyUtil';
import '../css/Detail.css';
import '../css/DetailVehicle.css';

export default class ButtonFormatter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
    };
  }

  handleDelete = async () => {
    const { row } = this.props;
    await this.submit(row);
  };

  handleEdit = () => {
    const { edit } = this.state;
    this.setState({
      edit: !edit,
    });
  };

  submit = async (module) => {
    const { onChangeList } = this.props;
    confirmAlert({
      title: 'Xóa module',
      message: `Bạn có chắc chắn xóa Module ID: ${module.module_id}`,
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            await ModuleApi.delete(module.module_id)
              .then(NotifyAlert('Thành công', `Xóa module thành công!`))
              .catch((err) =>
                NotifyAlert('Lỗi', `Đã xảy ra lỗi khi xoá module! ${err}`)
              );
            const { list } = this.props;
            list.forEach((item, index) => {
              if (item.id === module.module_id) list.splice(index, 1);
            });

            onChangeList(list);
          },
        },
        {
          label: 'No',
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const { row } = this.props;
    const canEdit = MyUtil.hasPermission('/module', 'update');
    return (
      <div className="div-edit">
        {canEdit && (
          <Link to={`/module/edit/${row.module_id}`}>
            <Button size="small" onClick={() => this.handleEdit()}>
              <i className="fas fa-edit"></i>
            </Button>
          </Link>
        )}

        {/* <img
          src="ic-delete.png"
          height="15"
          className="ic-edit"
          alt="Xóa"
          style={{ cursor: 'pointer' }}
          onClick={this.handleDelete}
        /> */}
      </div>
    );
  }
}
